import React from "react";
import DataDisplay from "../../../../../components/dataDisplay/dataDisplay";
import { useSelector } from "react-redux";

const TotalMembersCount = () => {
  const membersCount = useSelector(
    (state) => state.numberOfActiveMembersBy.totalData?.membersCount
  );
  return (
    <div className={"members-count"} data-testid={"TotalMembersCount"}>
      <DataDisplay value={membersCount?.total} color={"white"} size={60} disableAnimation={true} />
      <p className={"total-filter-text"}>{membersCount?.name}</p>
    </div>
  );
};

export default TotalMembersCount;
